import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.AddBeneficiaryPopupContent.NotificationError',
    {
        failed: 'The beneficiary was failed to be created in Airwallex with the reason',
        failedPlural: 'The beneficiary was failed to be created in Airwallex with the reasons',
    }
);
